class ScrollActiveHandler {
	private slides: HTMLElement[];
	private activeClass = 'hero-active';
	private isDesktop = window.matchMedia('(min-width: 992px)');
	private lottieAnimations: { [key: string]: typeof AnimationItem } = {};
	constructor() {
		this.slides = Array.from(document.querySelectorAll('.hero-trigger'));
		this.init();
	}

	private init() {
		this.isDesktop.addEventListener('change', this.onResize.bind(this));
		window.addEventListener('scroll', () => this.updateActiveClass());

		if (this.isDesktop.matches) {
			this.updateActiveClass();
			this.initDesktopAnimations();
		} else {
			// setup mobile animations
			this.removeActiveClass();
			this.initMobileAnimations();
		}
	}

	private onResize() {
		for (const key in this.lottieAnimations) {
			this.lottieAnimations[key].destroy();
		}
		if (this.isDesktop.matches) {
			this.updateActiveClass();

			this.initDesktopAnimations();
		} else {
			// setup mobile animations
			this.removeActiveClass();
			this.initMobileAnimations();
		}
	}

	private updateActiveClass() {
		let activeSlide: HTMLElement | null = null;

		for (let i = 0; i < this.slides.length; i++) {
			const slide = this.slides[i];
			const slideContainer = slide.querySelector<HTMLElement>('.container');
			if (slideContainer) {
				const isVisible = this.isElementInViewport(slideContainer);

				if (isVisible) {
					activeSlide = slide;
					break;
				}
			}
		}

		if (activeSlide) {
			this.setActiveSlide(activeSlide);
		}
	}

	private setActiveSlide(slide: HTMLElement) {
		this.slides.forEach((s) => s.classList.remove(this.activeClass));
		slide.classList.add(this.activeClass);
		const targetId = slide.dataset.trigger;
		const targetElement = document.querySelector(`[data-target="${targetId}"]`);
		const targetAnchorLink = document.querySelector(`[data-anchor-id="${slide.id}"]`);
		if (targetElement && !targetElement.classList.contains(this.activeClass)) {
			document
				.querySelectorAll(`[data-target]`)
				.forEach((el) => el.classList.remove(this.activeClass));
			targetElement.classList.add(this.activeClass);
			const lottieAnimation = targetElement.querySelector('[data-lottie]');
			if (lottieAnimation instanceof HTMLElement) {
				const lottieAnimationName = lottieAnimation.dataset.lottie;
				for (const key in this.lottieAnimations) {
					if (key === lottieAnimationName) {
						this.lottieAnimations[key].stop();
						this.lottieAnimations[key].play();
					}
				}
			}
		}
		if (targetAnchorLink) {
			document
				.querySelectorAll(`[data-anchor-id]`)
				.forEach((el) => el.classList.remove(this.activeClass));
			targetAnchorLink.classList.add(this.activeClass);
		}
	}

	private removeActiveClass() {
		this.slides.forEach((s) => s.classList.remove(this.activeClass));
		document
			.querySelectorAll(`[data-target]`)
			.forEach((el) => el.classList.remove(this.activeClass));
	}

	private isElementInViewport(el: HTMLElement): boolean {
		const rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}
	private initAnimations(querySelector: string) {
		const lottieElements = Array.from(document.querySelectorAll<HTMLElement>(querySelector));

		lottieElements.forEach((lottieElement) => {
			const animationName = lottieElement.dataset?.lottie;
			if (animationName) {
				this.lottieAnimations[animationName] = bodymovin.loadAnimation({
					container: lottieElement,
					path: `/wp-content/themes/wp-theme-clynk/assets/lottiefiles/${animationName}.json`,
					renderer: 'svg',
					autoplay: false,
					loop: false,
				});
			}
			lottieElement.addEventListener('click', this.handleAnimationClick.bind(this));
		});
	}

	private initDesktopAnimations() {
		this.initAnimations('.block-animated-hero__media-item [data-lottie]');
	}

	private initMobileAnimations() {
		this.initAnimations('.block-animated-hero-slide [data-lottie]');
	}

	private handleAnimationClick(e: Event) {
		if (!(e.target instanceof HTMLDivElement)) {
			return;
		}
		const animationName = e.target.dataset?.lottie;
		if (animationName) {
			this.lottieAnimations[animationName].stop();
			this.lottieAnimations[animationName].play();
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new ScrollActiveHandler();
});
